// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"120":"920413d3659b4f2f","976":"670d3d2d71313f45"}[chunkId] + ".js";
};